import React from "react";
import { Hero } from "../sections/hero/Hero";
import { ProudToServe } from "../sections/proud-to-serve/ProudToServe";
import { Technology } from "../sections/Technology";
import { Testimonials } from "../../common/layout/testimonials/Testimonials";
import { SEGMENT_BZA } from "../constants";
import { WhySubscribe } from "../sections/WhySubscribe";
import { ProductSlider } from "../sections/ProductSlider";
import { ProductTabs } from "../sections/ProductTabs";
import { Upgrades } from "../sections/Upgrades";
import { Trial } from "../sections/Trial";
import { Discover } from "../sections/Discover";
import { Faq } from "../sections/faq/Faq";
import { productSegmentPageProps } from "../../common/types/product";

export default function BusinessOperatorNews({
	packageName,
	subscribeLink,
	tabsNav,
	testimonials,
}: productSegmentPageProps) {
	return (
		<>
			<Hero
				title={packageName}
				subtitle={`Access the latest news in aviation and ch-aviation’s extensive knowledge database.`}
				packages={[
					{
						title: `${SEGMENT_BZA} News`,
						features: [
							"Latest news updates on Business Jets",
							"Extensive Business Jet Operator News database",
							"Access to exclusive stories and interviews",
							"ch-aviation weekly Business Jets Newsletter access",
							"News alerts",
							"News feed customisation – create favourite lists and see News To Go",
						],
						label: "Most Popular",
						subscribeLinkUrl: subscribeLink,
					},
				]}
			/>
			{tabsNav}
			<ProudToServe />
			<ProductTabs
				title={packageName}
				subtitle="What our newsroom reports on"
				tabs={[
					{
						title: "News",
						list: [
							"Corporate developments",
							"Fleet transactions",
							"Strategic announcements",
							"Regulatory",
							"Legal",
							"Financials and shareholdings",
							"Aeropolitics and government policy",
							"Airport Operations",
						],
						visual: {
							url: "/static/img/product/commercial-operator-news/news-search-bza.jpg",
						},
					},
				]}
			/>
			<ProductSlider
				title="News delivered where you need them"
				description="Read your morning briefing on the ch-aviation homepage, on the News page, access operator-specific stories in Operator profiles or stay up to date with the weekly ch-aviation newsletter."
				slides={[
					{
						title: "Customised homepage",
						description:
							"Read articles you need in your daily work",
						list: [
							"Stories users from your industry segment have been reading most",
							"Read articles you need in your daily work",
						],
						visual: {
							url: "/static/img/product/commercial-operator-news/home-page.jpg",
						},
					},
					{
						title: "News section",
						description:
							"This section of the platform features Latest News, but also specialised tabs for a better overview",
						list: [
							"Multiple tabs and categories to help navigation",
							"Latest News (all news in chronological order)",
							"General News (general business news related covering stories ranging from aircraft movements, networks, commercial, operator business models, investments, stock market announcements, airport networks, aeropolitics and more)",
							"Fleet News (aircraft orders from manufacturers, eVTOL orders, new dry leases, wet leases or damp leases, second-hand aircraft purchases, tender/RFP, and more) ",
							"Access News to Go (full article view on a single page, no need to open each article)",
							"News Search (search by category, operator, airport, manufacturer, aircraft type, geography, tags and more)",
							"Save searches",
							"Create news alerts",
						],
						visual: {
							url: "/static/img/product/commercial-operator-news/news-search-bza.jpg",
						},
					},
					{
						title: "Operator profiles",
						description:
							"See all articles linked to an operator via the Operator profile",
						list: [
							"Latest News (all news that mention an operator in chronological order)",
							"General News (general business news related covering stories ranging from aircraft movements, networks, commercial, operator business models, investments, stock market announcements, airport networks, aeropolitics and more)",
							"Fleet News (aircraft orders from manufacturers, eVTOL orders, new dry leases, wet leases or damp leases, second-hand aircraft purchases, tender/RFP, and more) ",
							"Access News Search",
						],
						visual: {
							url: "/static/img/product/commercial-operator-news/operator-profile-bza.jpg",
						},
					},
					{
						title: "Newsletter",
						description:
							"With over 40k subscribers, the ch-aviation newsletter is a must-read",
						list: [
							"Decide when it lands in your inbox",
							"Read full articles or titles only",
							"Create alerts for topics that matter most to you",
						],
						visual: {
							url: "/static/img/product/commercial-operator-news/operator-profile-bza.jpg",
						},
					},
				]}
			/>
			<WhySubscribe
				description="For over 20 years, ch-aviation has been a trusted source in aviation news, providing exclusive news and insights into the thoughts of decision-makers"
				list={[
					"24/5 global coverage",
					"Exclusive C-level interviews",
					"Global team of experienced journalists",
					"Integrated news archive",
					"Fully integrated platform, unifying news and data",
				]}
			/>
			<Upgrades
				packageName={packageName}
				modules={[
					{
						title: "ch-aviation newsroom content",
						content: "Access with every news subscription.",
						list: [
							"ch-aviation publishing channel: features original stories and deep-dives, including exclusive interviews with decision-makers",
							"ch-aviation brief: features quick updates on developments in aviation",
						],
					},
					{
						title: "ch-aviation automation",
						content: "Automated news feeds",
						list: [
							"Route Network Changes: available with the Schedules subscription",
							"Management Updates: available with the Contacts subscription",
						],
					},
				]}
			>
				<Trial subscribeLink={subscribeLink} />
			</Upgrades>
			<Testimonials testimonials={testimonials} />
			<Technology />
			<Discover subscribeLink={subscribeLink} />
			<Faq
				items={[
					{
						title: "How many reporters work for ch-aviation",
						content:
							"ch-aviation has a global newsroom of 10 members, including journalists and editors based in Austria, South Africa, Greece, Mexico, Serbia, Lithuania and Portugal).",
					},
					{
						title: "How does ch-aviation decide which topics to cover?",
						content:
							"ch-aviation’s editorial team functions independently from the rest of the business and selects stories most relevant to aviation industry professionals.",
					},
					{
						title: "Can I load more than 15 articles per page?",
						content:
							"Yes, you may select to see 15, 25, 50 or 100 articles per page by clicking on your preferred option at the top of the News page.",
					},
					{
						title: "I am in a hurry. What is the fastest way for me to stay updated?",
						content:
							"Get NewsToGo and select Full view under Layout on the top of the news page. This way, you can read more than one article just by scrolling down the page.",
					},
				]}
			/>
		</>
	);
}
